import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Authentication.css';
import UserPool from '../../UserPool';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import { jwtDecode } from 'jwt-decode';
import AWS from 'aws-sdk';
import { insertLog } from '../Logs/InsertLog';


function SignIn({ onLogin }) {
    const [email, setEmail] = useState(localStorage.getItem('rememberedEmail') || '');
    const [password, setPassword] = useState(localStorage.getItem('rememberedPassword') || '');
    const [isChecked, setIsChecked] = useState(localStorage.getItem('rememberMe') === 'true');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { showAlert, hud, stopHudRotation } = useCustomContext();
    const location = useLocation();


    useEffect(() => {
        const message = localStorage.getItem("SESSION_EXPIRED_MESSAGE");

        if (message) {
            showAlert(message, [
                {
                    label: "OK",
                    onClick: () => { },
                    color: "var(--buttonColor)",
                },
            ]);

            // 🧹 clear so it doesn't show again
            localStorage.removeItem("SESSION_EXPIRED_MESSAGE");
        }
    }, [showAlert]);

    // useEffect(() => {
    //     window.history.forward();
    //     const handlebackbutton = () => window.history.forward();
    //     window.history.pushState(null, null, window.location.pathname);
    //     window.addEventListener('popstate', handlebackbutton);
    //     return () => window.removeEventListener('popstate', handlebackbutton);
    // }, []);

    // AWS.config.update({
    //     // accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    //     // secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    //     region: process.env.REACT_APP_COGNITO_REGION
    // });

    // const cognitoISP = new AWS.CognitoIdentityServiceProvider();


    // const GoogleCustomattribute = async (username, Name) => {
    //     const empInfo = {
    //         name: Name,
    //         accessLevel: 1,
    //         isEmployeeApproved: false,
    //         isEmployeeActive: false,
    //     };

    //     try {
    //         await cognitoISP.adminUpdateUserAttributes({
    //             UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
    //             Username: username,
    //             UserAttributes: [
    //                 {
    //                     Name: 'custom:empInfo',
    //                     Value: JSON.stringify(empInfo),
    //                 },
    //                 {
    //                     Name: 'email_verified', Value: "true"
    //                 }
    //             ],
    //         }).promise();

    //         console.log('Custom attribute updated successfully');
    //     } catch (error) {
    //         console.error('Failed to update custom attributes:', error);
    //     }
    // };

    // const getUserDetailsFromCognito = async (cognitoUsername) => {
    //     try {
    //         const userData = await cognitoISP.adminGetUser({
    //             UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
    //             Username: cognitoUsername,
    //         }).promise();

    //         console.log('User Details:', userData);

    //         const attributes = {};
    //         userData.UserAttributes.forEach(attr => {
    //             attributes[attr.Name] = attr.Value;
    //         });

    //         const email = attributes.email;
    //         const empInfo = attributes['custom:empInfo'];
    //         const parsedEmpInfo = JSON.parse(empInfo);
    //         const accessLevel = parsedEmpInfo.accessLevel;

    //         localStorage.setItem('isEmployeeApproved', parsedEmpInfo.isEmployeeApproved);
    //         localStorage.setItem('isEmployeeActive', parsedEmpInfo.isEmployeeActive);
    //         localStorage.setItem('employeeName', parsedEmpInfo.name);
    //         localStorage.setItem('accessLevel', accessLevel);
    //         localStorage.setItem('UserStatus', userData.UserStatus);
    //         localStorage.setItem('email', email);
    //         localStorage.setItem('EmpInfo', empInfo);


    //         const isApproved = parsedEmpInfo.isEmployeeApproved === 'true' || parsedEmpInfo.isEmployeeApproved === true;
    //         const isActive = parsedEmpInfo.isEmployeeActive === 'true' || parsedEmpInfo.isEmployeeActive === true;
    //         const userName = email?.split('@')[0];

    //         if (isApproved && isActive) {
    //             // insertLog(
    //             //     `${userName} successfully signed in with Google and navigated to home screen.`,
    //             //     0,
    //             //     email,
    //             //     hud,
    //             //     stopHudRotation,
    //             //     showAlert
    //             // );
    //             return { success: true, email, accessLevel, isApproved, isActive };
    //         }
    //         else
    //         {
    //             // insertLog(
    //             //     `${userName} failed to signed in with Google.`,
    //             //     0,
    //             //     email,
    //             //     hud,
    //             //     stopHudRotation,
    //             //     showAlert
    //             // );
    //             navigate('/AccessDenied')
    //         }



    //     } catch (error) {
    //         console.error('Failed to get user details:', error);
    //         return { success: false, reason: 'Unable to fetch user details.' };
    //     }
    // };


    const handleEmailChange = (e) => {
        const value = e.target.value.replace(/\s+/g, "");
        setEmail(value);
        validateEmail(value);
    };

    const handleKeyDown = (e) => {
        if (e.key === " ") {
            e.preventDefault(); // block space key
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        validatePassword(value);
    };

    const validateEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmailErrorMessage(emailRegex.test(value) ? '' : 'Enter a valid email address.');
    };

    const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`+= -])[A-Za-z\d\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`+= -]{8,}$/;

    const validatePassword = (value) => {
        if (!value) {
            setPasswordErrorMessage("Password is required");
        } else if (value !== value.trim()) {
            setPasswordErrorMessage(
                "Password cannot start or end with a space"
            );
        } else if (/\s{2,}/.test(value)) {
            setPasswordErrorMessage(
                "Password cannot contain multiple consecutive spaces"
            );
        } else if (!passwordRegex.test(value)) {
            setPasswordErrorMessage(
                "Password must be at least 8 characters and include uppercase, lowercase, number, and special character"
            );
        } else {
            setPasswordErrorMessage("");
        }
    };

    const toggleShowPassword = () => setShowPassword(!showPassword);
    const handleCheckboxChange = () => setIsChecked(!isChecked);

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     onLogin(email);
    //     navigate('/Home');
    // };



    const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous error messages
        setEmailErrorMessage('');
        setPasswordErrorMessage('');

        // Validate fields
        validateEmail(email);
        validatePassword(password);

        // Check for any errors
        let hasError = false;

        if (!email) {
            setEmailErrorMessage("Enter your email address.");
            hasError = true;
        }

        if (!password) {
            setPasswordErrorMessage("Password is required");
            hasError = true;
        }

        if (
            password &&
            (
                password !== password.trim() ||
                /\s{2,}/.test(password) ||
                !passwordRegex.test(password)
            )
        ) {
            hasError = true;
        }

        if (emailErrorMessage) {
            hasError = true;
        }

        if (hasError) return;

        // Proceed with sign-in logic if valid
        const user = new CognitoUser({
            Username: email,
            Pool: UserPool,
        });
        hud("Please Wait...")
        try {
            const authDetails = new AuthenticationDetails({
                Username: email,
                Password: password.trim(),
            });

            // const userData = await cognitoISP.adminGetUser({
            //     UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
            //     Username: email,
            // }).promise();
            // localStorage.setItem('UserStatus', userData.UserStatus);

            await new Promise((resolve, reject) => {
                user.authenticateUser(authDetails, {
                    onSuccess: (data) => {
                        user.getUserAttributes((err, attributes) => {
                            if (err) {
                                stopHudRotation();
                                console.error('Error fetching user attributes:', err);
                                handleFailure('Error fetching user attributes');
                            } else {
                                stopHudRotation();
                                const idToken = data.getIdToken().getJwtToken();
                                const refreshToken = data.getRefreshToken().getToken();
                                console.log("idToken ", idToken);
                                console.log("refreshToken ", refreshToken);
                                localStorage.setItem("idToken", idToken);
                                localStorage.setItem("refreshToken", refreshToken);

                                localStorage.setItem('isUserLoggedIn', true);
                                localStorage.setItem('email', email);
                                localStorage.setItem('attributes', JSON.stringify(attributes));
                                const empInfoAttr = attributes.find(attr => attr.Name === 'custom:empInfo');
                                if (empInfoAttr) {
                                    try {
                                        const empInfo = JSON.parse(empInfoAttr.Value);
                                        if (!empInfo?.projectAccess?.["winter-soldier"].enabled) {
                                            showAlert(
                                                "You don’t have access to this project. Please contact the administrator.",
                                                [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
                                            );

                                            localStorage.setItem('isUserLoggedIn', false);
                                            return;
                                        }
                                        // Save full empInfo object
                                        localStorage.setItem('employeeInfo', JSON.stringify(empInfo));
                                        // Save individual fields
                                        if ('isEmployeeApproved' in empInfo) {
                                            localStorage.setItem('isEmployeeApproved', empInfo.isEmployeeApproved.toString());
                                        }

                                        if ('accessLevel' in empInfo) {
                                            localStorage.setItem('accessLevel', empInfo.accessLevel.toString());
                                        }

                                        if ('callAccess' in empInfo) {
                                            localStorage.setItem('callAccess', empInfo.callAccess.toString());
                                        }

                                        if ('isEmployeeActive' in empInfo) {
                                            localStorage.setItem('isEmployeeActive', empInfo.isEmployeeActive.toString());
                                        }

                                        if ('name' in empInfo) {
                                            localStorage.setItem('employeeName', empInfo.name);
                                        }

                                        const project = empInfo.projectAccess?.["winter-soldier"];

                                        let datasets = [];

                                        if (project?.enabled && Array.isArray(project?.datasets)) {
                                            datasets = project.datasets;
                                        } else {
                                            console.warn("No valid datasets or project disabled");
                                        }
                                        localStorage.setItem('winterSoldierDatasets', JSON.stringify(datasets));
                                        console.log('Saved datasets:', datasets);


                                    } catch (e) {
                                        console.error('Failed to parse empInfo:', e);
                                    }
                                }


                                // console.log('attributes', attributes)
                                if (isChecked) {
                                    localStorage.setItem('rememberMe', 'true');
                                    localStorage.setItem('rememberedEmail', email);
                                    localStorage.setItem('rememberedPassword', password);
                                } else {
                                    localStorage.removeItem('rememberMe');
                                    localStorage.removeItem('rememberedEmail');
                                    localStorage.removeItem('rememberedPassword');
                                }
                                const isApproved = localStorage.getItem('isEmployeeApproved') === 'true';
                                const isActive = localStorage.getItem('isEmployeeActive') === 'true';
                                const useremail = localStorage.getItem("email");
                                const accessLevel = parseInt(localStorage.getItem("accessLevel"), 10);
                                const userName = useremail?.split('@')[0];

                                if (isApproved && isActive) {
                                    onLogin(email);
                                    navigate('/Datasets');
                                    insertLog(
                                        `${userName} successfully signed in and navigated to Home screen.`,
                                        0,
                                        useremail,
                                        hud,
                                        stopHudRotation,
                                        showAlert,
                                        '',        // activityId
                                        'GET',     // activityType
                                        'SignIn',  // activityService
                                        'SUCCESS', // activityStatus
                                        ''         // activityErrorMsg
                                    );

                                }
                                else {
                                    navigate("/AccessDenied");
                                }

                            }
                        });
                        resolve();
                    },
                    onFailure: (err) => {
                        stopHudRotation();

                        // ❌ Handle unconfirmed user directly here (better)
                        if (err.code === "UserNotConfirmedException") {
                            showAlert(
                                "Account not verified. Code sent again.",
                                [{
                                    label: "Verify Now", onClick: () => {
                                        user.resendConfirmationCode((error) => {
                                            if (!error) {
                                                handleVerifyEmail()
                                            }
                                        });
                                    }, color: "var(--buttonColor)"
                                }]
                            );
                            reject({ handled: true, originalError: err });
                        } else {
                            insertLog(
                                `${email?.split('@')[0]} failed to sign in.`,
                                0,
                                email,
                                hud,
                                stopHudRotation,
                                showAlert,
                                '',
                                'GET',
                                'SignIn',
                                'FAILED',
                                err.message
                            );
                            handleFailure(err.message);
                            reject({ handled: true, originalError: err });
                        }
                    },
                });
            });

        } catch (error) {
            if (!error?.handled) {
                handleCatchError(error?.originalError || error);
            }
            stopHudRotation();

        }
    };

    const handleVerifyEmail = () => {
        navigate("/VerifyEmail", { state: { email } });
    }

    const handleFailure = (message) => {
        stopHudRotation();
        showAlert(message, [
            { label: 'Ok', color: 'var(--buttonColor)', onClick: () => { } }
        ]);
        localStorage.setItem('isUserLoggedIn', false);
    };

    const handleCatchError = (error) => {
        if (error.code === "UserNotConfirmedException") {
            return
        }
        if (error.response) {
            console.error('Response Error:', error.response.data);
        } else if (error.request) {
            console.error('Request Error:', error.request);
        } else {
            console.error('Error:', error.message);
        }

        showAlert(error.message, [
            { label: 'Ok', color: 'var(--buttonColor)', onClick: () => { } }
        ]);

    };

    const handleGoogleLogin = () => {
        const clientId = process.env.REACT_APP_COGNITO_CLIENTID;
        const domain = "us-east-1z0mtkhk91.auth.us-east-1.amazoncognito.com";
        const redirectUri = ""; // or your local URI
        // const redirectUri = "http://localhost:3000"; // or your production URI

        const responseType = 'code';
        const scope = 'openid profile email';

        const queryParams = new URLSearchParams({
            identity_provider: 'Google',
            redirect_uri: redirectUri,
            response_type: responseType,
            client_id: clientId,
            scope: scope,
            prompt: 'select_account'
        });

        window.location.href = `https://${domain}/oauth2/authorize?${queryParams.toString()}`;

    };


    return (
        <div className='centered-content container d-flex flex-column align-items-center login-hub'>
            <span className="heading-span mb-2">{process.env.REACT_APP_NAME}</span>
            <span className='font-weight-bold mb-3 logo'>
                Welcome to {process.env.REACT_APP_NAME}. Please sign in to your account.
            </span>
            <div className='input-container mb-3 w-100'>
                <div className='d-flex justify-content-center w-100'>
                    <form onSubmit={handleSubmit} className='form-container' autoComplete='off'>
                        <input type="text" name="fake-user" style={{ display: "none" }} />
                        <input type="password" name="fake-pass" style={{ display: "none" }} />
                        <div className='form-group mb-3'>
                            <input
                                className={`form-control ${emailErrorMessage ? 'is-invalid' : email ? 'is-valid' : ''} inputs`}
                                type='text'
                                placeholder='Email'
                                value={email}
                                onChange={handleEmailChange}
                                onKeyDown={handleKeyDown}
                                name="user_login_email"
                                autoComplete="off"
                            />
                            {emailErrorMessage && <div className='invalid-feedback error-message'>{emailErrorMessage}</div>}
                        </div>
                        <div className='form-group'>
                            <div className='password-container'>
                                <input
                                    className={`form-control ${passwordErrorMessage ? 'is-invalid' : password ? 'is-valid' : ''} inputs`}
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder='Password'
                                    value={password}
                                    onChange={handlePasswordChange}
                                    name='password-field'
                                    autoComplete="new-password"
                                />
                                <span
                                    className='password-toggle-icon'
                                    onClick={toggleShowPassword}
                                    style={{
                                        right: passwordErrorMessage ? '40px' : '10px',
                                        top: '8px'
                                    }}
                                >
                                    {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                                </span>
                                {passwordErrorMessage && <div className='invalid-feedback error-message'>{passwordErrorMessage}</div>}
                            </div>
                        </div>

                        <div className='d-flex justify-content-between align-items-center mb-3'>
                            <div className='form-check'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id='checkbox-text'
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    style={{ cursor: 'pointer' }}
                                />
                                <label className='form-check-label' htmlFor='checkbox-text'>
                                    Remember Me
                                </label>
                            </div>
                            <Link to="/ForgotPassword" className="text-decoration-underline customs-link">
                                Forgot Password?
                            </Link>
                        </div>

                        <button className='btn btn-primary submit btn-block mt-1 submit-button' type='submit'>
                            Sign In
                        </button>
                    </form>
                </div>
            </div>

            {/* Google Login Button */}

            {/* <div className=" text-center mt-1">
                <button
                    className="mb-2 google-btn "
                    onClick={handleGoogleLogin}

                >
                    <img
                        src="https://developers.google.com/identity/images/g-logo.png"
                        alt="Google"
                        style={{ width: '20px', marginRight: '10px', verticalAlign: 'middle' }}
                    />
                    Continue with Google
                </button>
            </div> */}
            {/* <div className="OR-line"><div className="line"></div><div className="NameOR">OR</div><div className="line"></div></div> */}
            <div className='form-group mb-3 text-center'>
                <p>
                    Don't have an account?{' '}
                    <Link to="/SignUp" className="text-decoration-underline custom-link2">
                        Sign Up
                    </Link>
                </p>
            </div>
        </div>
    );
}

export default SignIn;
